import { OFFERS_OFFICE_TYPES } from 'shared/constants/buildingLabels';
import type { IOffersFilters, IOffersSort, TOffersPropertyType } from 'shared/types/buildingOffers';

import { getOffersCategory } from './offersFilters';
import { getOffersApiSort, type TOffersApiSort } from './offersSort';

/** Те же сортировки в значениях выдачи (`api/offer.ts` монолита) */
const LISTING_SORTS: Record<TOffersApiSort, string> = {
  priceAsc: 'price_object_order',
  priceDesc: 'total_price_desc',
  pricePerMeterAsc: 'price_square_order',
  areaAsc: 'total_area_asc',
};

interface IParams {
  buildingId: number;
  filters: IOffersFilters & { propertyType: TOffersPropertyType };
  sort: IOffersSort | null;
}

/**
 * Ссылка «Показать все…» на выдачу текущей выборки. В монолите её строит прокси из того же запроса
 * (`get_offers_url`): относительная, параметры — в порядке сериализации монолита
 */
export function getOffersListingUrl({ buildingId, filters, sort }: IParams): string {
  const { dealType, propertyType, isFromRepresentative } = filters;
  const apiSort = getOffersApiSort(dealType, sort);
  const listingSort = apiSort && LISTING_SORTS[apiSort];
  const params = [
    `bs_center_id=${buildingId}`,
    `cats[0]=${getOffersCategory(dealType, propertyType)}`,
    `deal_type=${dealType}`,
    'engine_version=2',
    `from_offrep=${isFromRepresentative ? 1 : 0}`,
    'offer_type=offices',
    `office_type[0]=${OFFERS_OFFICE_TYPES[propertyType]}`,
    ...(listingSort ? [`sort=${listingSort}`] : []),
  ];

  return `/cat.php?${params.join('&')}`;
}
